import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { aiSkillsWanted, useAiSkills } from '@/hooks/useAiSkills';
import { useAppConfig } from '@/hooks/useAppConfig';
import { closedRedirect } from '@/lib/aiEntries';
import { aiSkillsLoaded } from '@/lib/aiSkills';
import { useAuthStore } from '@/stores/auth';

/**
 * Маршрут закрытого входа: по прямому адресу — в тренажёры с объяснением.
 *
 * ⚠️ СПРЯТАТЬ КАРТОЧКИ МАЛО. Адрес живёт в закладках, в истории браузера и в
 * заданиях куратора; без перенаправления человек открыл бы экран мимо всех
 * спрятанных кнопок. Проверка — `aiGate.test.ts`.
 */
export function AiGate({ path, children }: { path: string; children: ReactNode }) {
  // Настройки приезжают после первой отрисовки: без подписки экран остался бы
  // на умолчании до перезагрузки.
  useAppConfig();
  // Тумблеры навыков (docs/CONTRACTS/ai-skills.md) — тоже запросом. Пока ответа
  // нет, не уводим: иначе прямой адрес открытого навыка уходил бы на хаб.
  // Ждёт только тот, кому ручка нужна по тарифу; бесплатника гейт уводит сразу
  // (ручку ему не зовём — aiSkillsWanted).
  const user = useAuthStore((s) => s.user);
  useAiSkills();
  if (aiSkillsWanted(user) && !aiSkillsLoaded()) return null;
  const to = closedRedirect(path);
  if (to) return <Navigate to={to} replace />;
  return <>{children}</>;
}
